// @flow
import React from "react";
import {Spin} from "antd";
import {useObserver} from "mobx-react-lite";

import {useStore} from "../../../hooks/useStore";
import {Container} from "./LoadingStyles";

export const Loading = () => {
    const stores = useStore();

    return useObserver(() => (
        <Container spinning={stores.appStore.loading}>
            <Spin size="large" spinning={stores.appStore.loading}></Spin>
        </Container>
    ));
};
